import { render, staticRenderFns } from "./ItemInstitucion.vue?vue&type=template&id=ad5798b2&"
import script from "./ItemInstitucion.vue?vue&type=script&lang=js&"
export * from "./ItemInstitucion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports